import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {ICentros} from '../modelos/ICentros';

@Injectable({
  providedIn: 'root'
})
export class CentrosService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtenerTodo(): Observable<ICentros[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.centros.obtenerTodo
    );
  }
}
